import { useMutation } from '@apollo/client';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateError, useUpdateSuccess } from '@famly/stat_ts-utils_global-messages';
import { defaultErrorDuration, defaultSuccessDuration } from 'web-app/react/global-event/helpers/constants';
import { pinLogout } from 'signin-app/pin/actions';
import translate from 'signin-app/helpers/translate';
import * as Queries from './queries';
export const useRemoteOpenDoor = (siteId, loginId, expiration, hmac) => {
    const [openDoor] = useMutation(Queries.RemoteOpenDoor);
    const dispatch = useDispatch();
    const updateError = useUpdateError();
    const updateSuccess = useUpdateSuccess();
    return React.useCallback(async () => {
        if (!siteId || !loginId || !expiration || !hmac) {
            return;
        }
        // Initiate the open door mutation
        openDoor({
            variables: {
                siteId,
                loginId,
                expiration,
                hmac,
            },
            onError: error => {
                updateError(error.message, { duration: defaultErrorDuration });
            },
        }).then(result => {
            if (!result.data) {
                return;
            }
            const { interval } = result.data.doorLocking.openDoor;
            updateSuccess(translate('doorIsOpen', {
                count: interval,
                interval,
            }), {
                duration: defaultSuccessDuration,
            });
        });
        // And log the user out immediately
        dispatch(pinLogout.action());
    }, [openDoor, siteId, loginId, dispatch, expiration, hmac, updateError, updateSuccess]);
};
